module.exports = __webpack_public_path__ + "static/media/marilyns-website-screenshot.78af2e8d.png";